import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { requestLogin } from '../appStore/commonSlice';
import { desencriptar, encriptar } from '../utils';
import AutenticarLoading from './GlobalFeedback/AutenticarLoading';
import { setNotification } from './GlobalFeedback/feedbackSlice';

const Autenticar = () => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let Hr61GyBgEdh3 = params.Hr61GyBgEdh3;
  let error = params.error;
  const history = useHistory();
  const dispatch = useDispatch();
  const [, setShowModal] = useState(false);
  const [, setErrorMsg] = useState('');

  const toggleModal = (toggle) => {
    setErrorMsg('');
    setShowModal(toggle);
    if (!toggle) history.push('/');
  };

  const login = async (cuil, password) => {
    dispatch(
      requestLogin({
        cuil,
        password,
      }),
    ).then((res) => {
      if (res.error) {
        setErrorMsg(res.error.message);
      } else {
        dispatch(
          setNotification({
            variant: 'success',
            msg: 'Login exitoso.',
          }),
        );
        toggleModal(false);

        const location = {
          pathname: '/',
        };
        history.push(location);
      }
    });
  };

  const handleErrorPage = (error) => {
    switch (error) {
      // TODO: Fix: Delete del caso de validacion de nivel de clave fiscal 3
      // case 'nivelInvalido':
      //   history.push({
      //     pathname: '/error-autenticar',
      //     state: {
      //       titulo: '¡Error! Nivel Invalido',
      //       descripcion: 'No posees el nivel para operar en el sistema (Nivel 3)',
      //     },
      //   });
      //   break;
      //   case 'personaInvalida':
      //     history.push({
      //       pathname: '/error-autenticar',
      //       state: {
      //         titulo: '¡Error! Persona Invalida',
      //         descripcion: 'No posees el nivel para operar en el sistema (Nivel 3)',
      //       },
      //     });
      //     break;
      case 'tokenInvalido':
        history.push({
          pathname: '/error-autenticar',
          state: {
            titulo: '¡Error! Token Invalido',
            descripcion: 'No posees un token valido para operar en el sistema.',
          },
        });
        break;
      default:
        console.log(error);
    }
  };

  const handleLogin = async () => {
    if (Hr61GyBgEdh3) {
      const parametros_url = await desencriptar(Hr61GyBgEdh3);
      const cuil = parametros_url.split('&')[0].split('=')[1];
      const origen = parametros_url.split('&')[1].split('=')[1];
      //seteo origen en store
      localStorage.setItem('origen', origen);
      const password = await encriptar(cuil);
      await login(cuil, password);
    } else if (error) {
      handleErrorPage(error);
    }
  };

  useEffect(() => {
    handleLogin();
  }, []);

  return (
    <Container>
      <AutenticarLoading />
    </Container>
  );
};

export default Autenticar;
